/* eslint-disable no-unused-vars */
import { Form, Input } from 'antd'
import React, { useEffect, useMemo, useState } from 'react'
import ReactQuill, { Quill } from 'react-quill'
import { client } from '@utils/client'
import 'react-quill/dist/quill.snow.css'
import { useLocalization } from '@contexts/LocalizationContext'
import { wellKidzClubError, wellKidzClubPrivileges } from './List'
import PropTypes from 'prop-types'
const Size = Quill.import('formats/size')
Size.whitelist = ['nomal']
Quill.register(Size, true)

const PrivilegesTh = ({ isEdit, handleSubmit, form }) => {
  const { t } = useLocalization()

  const [isCheckConditionTh, setIsCheckConditionTh] = useState(false)

  const modules = {
    toolbar: [
      [{ size: Size.whitelist }],
      // [{ color: [] }, { background: [] }],
      ['bold', 'underline'],
      [{ list: 'ordered' }, { list: 'bullet' }],
      ['image'],
    ],
  }
  const formats = [
    'size',
    'bold',
    // 'color',
    // 'background',
    'underline',
    'list',
    'image',
    'bullet',
  ]

  const handleChangeReactQuillTh = (content, _delta, _source, editor) => {
    form.setFieldsValue({ content: content })
    setIsCheckConditionTh(false)
    if (editor.getLength() < 2) {
      form.resetFields(['content'])
      setIsCheckConditionTh(true)
    }

    form.validateFields(['content'])
  }

  const formMemo = useMemo(
    () => (
      <Form
        layout="vertical"
        form={form}
        name="control-hooks"
        onFinish={(data) => {
          console.log(data)
          handleSubmit(data, 'th')
        }}
        onFinishFailed={(e) => {
          const errorCondition = e.errorFields.find((error) =>
            error.name.includes('content')
          )
          if (errorCondition) setIsCheckConditionTh(true)
        }}
        requiredMark={false}
      >
        <div hidden>
          <Form.Item name="id">
            {/* ฝาก Id ไปกับ Form เนื่องจากเป็น modal ฝากไปกับ path ไม่ได้ */}
            <Input />
          </Form.Item>
        </div>
        <Form.Item
          name="content"
          rules={[
            {
              required: true,
              validator: (_, value) => {
                if (!value || isCheckConditionTh) {
                  return Promise.reject(
                    `${t(`${wellKidzClubError}.pleaseEnter`)}${t(
                      `${wellKidzClubPrivileges}.specialPrivileges`
                    )}`
                  )
                }
                return Promise.resolve()
              },
            },
          ]}
        >
          <ReactQuill
            className={`reactQuill editReactQuillPrivileges  ${
              isCheckConditionTh ? 'ErrorReactQuill' : ''
            }  ${!isEdit ? 'editReactQuillBgReadOnly' : ''}`}
            readOnly={!isEdit}
            theme={'snow'}
            onChange={handleChangeReactQuillTh}
            modules={modules}
            formats={formats}
            preserveWhitespace
          />
        </Form.Item>
      </Form>
    ),
    [isEdit]
  )

  return <div>{formMemo}</div>
}

PrivilegesTh.propTypes = {
  handleSubmit: PropTypes.func,
  isEdit: PropTypes.bool,
  form: PropTypes.any,
}

export default PrivilegesTh
